import { isEmpty } from "lodash-es";

import { TRANSLATED_FACET_TK_PREFIX } from "@components/Search/SearchResults/StateComponents/Facets/Facet/facet.component";

export const getTranslatedFacetName = (
    originalFacetName: string,
    t: (key: string, ...params: Array<string | number | undefined>) => string,
) => {
    const translatedFacetName = t(
        `${TRANSLATED_FACET_TK_PREFIX}${originalFacetName}`,
    );

    return isEmpty(translatedFacetName) ||
        translatedFacetName.startsWith(TRANSLATED_FACET_TK_PREFIX)
        ? originalFacetName
        : translatedFacetName;
};
